<template>
  <bm-modal v-model="opened">
    <alert-message
      v-if="alert"
      :alert="alert" />
    <div slot="buttons">
      <button
        :class="buttonClass"
        type="button"
        class="btn btn-lg"
        @click="opened = false">
        Ok
      </button>
    </div>
  </bm-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import AlertMessage from './AlertMessage';
import bmModal from '../_modals/KezModal';

export default {
  components: {
    bmModal,
    AlertMessage,
  },
  data() {
    return {
      alert: null,
      opened: false,
    };
  },
  computed: {
    ...mapGetters('alert', ['firstUnviewedAlert']),
    buttonClass() {
      if (!this.alert || !this.alert.variant) {
        return 'btn-danger';
      }

      switch (this.alert.variant) {
        case 'success':
          return 'btn-success';
        default:
          return 'btn-danger';
      }
    },
  },
  watch: {
    firstUnviewedAlert(val) {
      if (val) {
        this.alert = val;
        this.opened = true;
      }
    },
    opened(isOpen) {
      if (!isOpen) {
        if (this.alert) {
          this.$store.dispatch('alert/remove', this.alert);
        }
      }
    },
  },
};
</script>
